import { render, staticRenderFns } from "./split-order-modal.vue?vue&type=template&id=c1d71300&scoped=true"
import script from "./split-order-modal.vue?vue&type=script&lang=js"
export * from "./split-order-modal.vue?vue&type=script&lang=js"
import style0 from "./split-order-modal.vue?vue&type=style&index=0&id=c1d71300&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1d71300",
  null
  
)

export default component.exports